import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { SupabaseTest } from '../components/supabase-test'
import { TestAuthService } from '@/services/test-auth-service'

// Add this button component to your app to test Sentry's error tracking
function ErrorButton() {
  return (
    <button
      onClick={() => {
        throw new Error('This is your first error!')
      }}
    >
      Break the world
    </button>
  )
}

export const Route = createFileRoute('/test')({
  beforeLoad: () => {
    if (typeof window === 'undefined') return
    if (!TestAuthService.verificarAcesso()) {
      throw redirect({ to: '/test-login' })
    }
  },
  component: TestComponent,
})

function TestComponent() {
  const navigate = useNavigate()

  const handleLogout = () => {
    TestAuthService.removerAcesso()
    navigate({ to: '/test-login' })
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Button variant="outline" onClick={handleLogout}>
          Sair
        </Button>
      </div>
      <SupabaseTest />
      <ErrorButton />
    </div>
  )
}